import type { FC, ReactNode } from 'react'

import { SilkRibbon } from '@/components/landing/silk-ribbon'
import { ContactForm } from '@/components/landing/contact-form'

export const ContactSection: FC = (): ReactNode => {
    return (
        <section
            id='contact'
            aria-labelledby='contact-title'
            className='relative isolate flex min-h-svh items-center overflow-hidden bg-background'
        >
            <div
                className='pointer-events-none absolute inset-0 -z-10 mx-auto hidden max-w-[1264px] border-x border-border lg:block'
                aria-hidden='true'
            />

            {/* Oversized by 2rem on every side so the slow drift never reveals the ribbon's edges. */}
            <div
                className='pointer-events-none absolute -inset-8 -z-10 animate-in fade-in duration-1000 motion-reduce:animate-none'
                aria-hidden='true'
            >
                <SilkRibbon className='size-full animate-ribbon-drift will-change-transform motion-reduce:animate-none' />
            </div>

            <div className='mx-auto flex w-full max-w-[1264px] justify-center px-4 py-24 sm:px-6 sm:py-32'>
                <ContactForm />
            </div>
        </section>
    )
}
